import { render } from "./CadSolicitacaoView.vue?vue&type=template&id=4449ea8c"
import script from "./CadSolicitacaoView.vue?vue&type=script&lang=js"
export * from "./CadSolicitacaoView.vue?vue&type=script&lang=js"

import "./CadSolicitacaoView.vue?vue&type=style&index=0&id=4449ea8c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__